import { render, staticRenderFns } from "./formIndicador.vue?vue&type=template&id=35de2d12&"
import script from "./formIndicador.vue?vue&type=script&lang=ts&"
export * from "./formIndicador.vue?vue&type=script&lang=ts&"
import style0 from "./formIndicador.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports